import { Record } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { class_type, option_type, string_type, bool_type, record_type, list_type, int32_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";

export class Paginated$1 extends Record {
    constructor(Page, PageSize, PageCount, Items) {
        super();
        this.Page = (Page | 0);
        this.PageSize = (PageSize | 0);
        this.PageCount = (PageCount | 0);
        this.Items = Items;
    }
}

export function Paginated$1_$reflection(gen0) {
    return record_type("Bfs.Web.Data.Service.Contracts.Paginated`1", [gen0], Paginated$1, () => [["Page", int32_type], ["PageSize", int32_type], ["PageCount", int32_type], ["Items", list_type(gen0)]]);
}

export class BoolResult extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function BoolResult_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.BoolResult", [], BoolResult, () => [["Value", bool_type]]);
}

export class AnsprechpartnerkontaktData extends Record {
    constructor(AnsprechpartnerName, Telefon, HatFoto) {
        super();
        this.AnsprechpartnerName = AnsprechpartnerName;
        this.Telefon = Telefon;
        this.HatFoto = HatFoto;
    }
}

export function AnsprechpartnerkontaktData_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.AnsprechpartnerkontaktData", [], AnsprechpartnerkontaktData, () => [["AnsprechpartnerName", string_type], ["Telefon", option_type(string_type)], ["HatFoto", bool_type]]);
}

export class UploadResult extends Record {
    constructor(Id, Dateiname, Size) {
        super();
        this.Id = Id;
        this.Dateiname = Dateiname;
        this.Size = (Size | 0);
    }
}

export function UploadResult_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.UploadResult", [], UploadResult, () => [["Id", class_type("System.Guid")], ["Dateiname", string_type], ["Size", int32_type]]);
}

export const Headers_kundenPortalAuth = "BfsBackendKundenPortalAuth";

export const Headers_patientenPortalAuth = "BfsBackendPatientenPortalAuth";

export const Headers_apiToken = "ApiToken";

//# sourceMappingURL=Contracts.fs.js.map
